import React from 'react'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { useSurveyForSettingsQueryBrandGroups } from '~/hooks/useSurveyForSettingsQuery'
import { findByPath } from '~/utils'

import { pathKey } from '../utils'

export const useBrandGroup = () => {
  const { brandGroupId } = usePathParams(pathKey)
  const brandGroups = useSurveyForSettingsQueryBrandGroups()

  return React.useMemo(
    () => findByPath(brandGroups, 'id', Number(brandGroupId)),
    [brandGroupId, brandGroups],
  )
}
